import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { DrivingTestDetailsHistory } from 'teacher-ui-client/reporting/ui-scope/re/student-summary/driving-tests/template'
import type { StudentScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export interface DrivingTestDetailsHistoryResponse {
  driving_test_details_history: {
    category: 'letters_and_sounds' | 'content_words' | 'sight_words'
    created_at: number
    passed: boolean
    quiz_position: number
    correct_answers: Nullable<string[]>
    incorrect_answers: Nullable<Record<string, string>>
  }[]
}

export async function drivingTestDetailsHistory(
  this: StudentEventsService,
  product: LegacyProductRe,
  statsScope: StudentScope,
  period: NormalizedInterval,
): Promise<Nullable<DrivingTestDetailsHistory[]>> {
  if (isEmpty(statsScope.ids)) return null
  const url = this.buildUrl('driving_test_details_history', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<DrivingTestDetailsHistoryResponse>(url, query)
  if (!data) return null

  const { driving_test_details_history } = data
  if (driving_test_details_history.length === 0) {
    return null
  }

  const detailsHistoryData = [...driving_test_details_history].map((item) => {
    return {
      ...item,
      correct_answers: item.correct_answers ?? [],
      incorrect_answers: item.incorrect_answers ?? {},
    }
  })

  return detailsHistoryData
}
